import React, { useEffect, useState } from 'react'
import BookLibrary from './BookLibrary'
import NewsLibrary from './NewsLibrary'

import styles from './style/search-content-mod.module.less'
import './style/global.less'

function SearchContentMod(props) {
  // tab切换
  const [tabActive, setTabActive] = useState<number>(0)

  return (
    <div className={styles['content']}>
      <div className={styles.tabList}>
        <div
          className={`${styles.tabItem} ${
            tabActive === 0 ? styles.active : ''
          }`}
          onClick={() => {
            setTabActive(0)
          }}>
          书刊库
        </div>
        <div
          className={`${styles.tabItem} ${
            tabActive === 1 ? styles.active : ''
          }`}
          onClick={() => {
            setTabActive(1)
          }}>
          新闻库
        </div>
      </div>
      {tabActive === 0 ? (
        <BookLibrary />
      ) : tabActive === 1 ? (
        <NewsLibrary />
      ) : (
        <div>暂无数据！</div>
      )}
    </div>
  )
}

export default SearchContentMod
